import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Trophy, CalendarDays, Target, ListOrdered, User } from "lucide-react";

const items = [
  { to: "/", icon: Trophy, key: "leagues" },
  { to: "/predict", icon: Target, key: "predict" },
  { to: "/matches", icon: CalendarDays, key: "matches" },
  { to: "/standings", icon: ListOrdered, key: "table" },
  { to: "/profile", icon: User, key: "profile" },
] as const;

export const BottomNav = () => {
  const { t } = useTranslation();
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 border-t bg-background/95 backdrop-blur md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      <ul className="grid grid-cols-5">
        {items.map(({ to, icon: Icon, key }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={to === "/"}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className={({ isActive }) =>
                `flex flex-col items-center gap-0.5 py-2 text-[10px] font-medium transition ${
                  isActive ? "text-primary" : "text-muted-foreground"
                }`
              }>
              <Icon className="h-5 w-5" />
              <span>{t(`nav.${key}`)}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};
